import { TCreateRegisterSupportOrganizationReqDto } from "@/api/services/admin/rso/dtos/create-rso.dto";
import { TGetRegisterSupportOrganizationDto } from "@/api/services/admin/rso/dtos/get-rso.dto";
import { TUpdateRegisterSupportOrganizationReqDto } from "@/api/services/admin/rso/dtos/update-rso.dto";
import { TGetUserDto } from "@/api/services/admin/rso/user/dtos/get-user.dto";
import { DATE_NOT_TIMEZONE_FORMAT } from "@/constants/datetime";
import { TRegisterSupportOrganizationForm } from "@/features/rso/types/registerSupportOrganizationForm";
import { TUpdateRsoUserForm } from "@/features/rso/types/updateRsoUserForm";
import { dayjs } from "@/utils/dayjs";

export const convertRsoFormToCreateReq = (
  data: TRegisterSupportOrganizationForm,
  organizationId: number | string,
  productContractId: number | string,
): TCreateRegisterSupportOrganizationReqDto => {
  return {
    organizationType: data.organizationType,
    rsoName: data.rsoName,
    rsoRegistrationNumber: data.rsoRegistrationNumber,
    contractStatus: data.contractStatus,
    contractPlan: data.contractPlan ?? null,
    note: data.note ?? null,
    description: data.description ?? null,
    allowedIps: data.allowedIps ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractStartDate: data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    startReportYear: data.startReportYear.get("year"),
    organizationId: Number(organizationId),
    productContractId: Number(productContractId),
  };
};

export const convertRsoFormToUpdateReq = (data: TRegisterSupportOrganizationForm): TUpdateRegisterSupportOrganizationReqDto => {
  return {
    ...data,
    contractPlan: data.contractPlan ?? null,
    note: data.note ?? null,
    description: data.description ?? null,
    allowedIps: data.allowedIps ?? null,
    trialStartDate: data.trialStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    trialEndDate: data.trialEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    contractStartDate: data.contractStartDate ? data.contractStartDate?.format(DATE_NOT_TIMEZONE_FORMAT) : null,
    contractEndDate: data.contractEndDate?.format(DATE_NOT_TIMEZONE_FORMAT) ?? null,
    startReportYear: data.startReportYear.get("year"),
  };
};

export const convertRsoResToForm = (data: TGetRegisterSupportOrganizationDto): TRegisterSupportOrganizationForm => {
  return {
    organizationType: data.organizationType ?? [],
    rsoName: data.rsoName,
    rsoRegistrationNumber: data.rsoRegistrationNumber,
    contractStatus: data.contractStatus,
    contractPlan: data.contractPlan ?? null,
    description: data.description ?? null,
    allowedIps: data.allowedIps ?? null,
    note: data.note ?? null,
    trialStartDate: data.trialStartDate ? dayjs(data.trialStartDate) : null,
    trialEndDate: data.trialEndDate ? dayjs(data.trialEndDate) : null,
    contractEndDate: data.contractEndDate ? dayjs(data.contractEndDate) : null,
    contractStartDate: data.contractStartDate ? dayjs(data.contractStartDate) : null,
    startReportYear: dayjs().year(data.startReportYear),
  };
};

export const convertRsoUserResToForm = (data: TGetUserDto): Partial<TUpdateRsoUserForm> => {
  return {
    email: data.email,
    fullName: data.fullName,
    isRsoAdmin: data.isRsoAdmin ? 1 : 0,
    isRsoUser: Number(data.isRsoUser),
    activeStatus: data.activeStatus ?? null,
  };
};
